export default {
    message: {
        currencySymbol: "$",
        currencyDesc: "USD",
        tiers: {
            t1: {
                label: "Workspace Standard",
                cost: "7",
                desc: "<p>Includes SSO and multifactor authentication for all apps; intelligent capabilities like microapps and personalized feeds; Citrix Content Collaboration Standard service with unlimited file storage.</p>"
            },
            t2: {
                label: "Workspace Premium",
                cost: "18",
                desc: "<p>Includes Workspace Standard functionality, plus advanced security controls for SaaS and web, unified endpoint management, and Content Collaboration Premium.</p>"
            },
            t3: {
                label: "Workspace Premium Plus",
                cost: "25",
                desc: "<p>Includes Workspace Premium functionality, plus a cloud management option for Citrix Virtual Apps and Desktops.</p>"
            },
            t4: {
                label: "Workspace Essentials",
                cost: "2",
                desc: "<p>Includes SSO to SaaS and web applications with multi-factor authentication, helping to reduce the odds of account compromise by 99.9%.</p>"
            },
            terms: "*Per user, per month",
            btn1: "View feature matrix"
        },
        features: {
            disclaimer1: "*USD MSRP monthly average per user for 500 users with a 3-year subscription. Actual pricing may vary.<br />Citrix Workspace licensing options start at 25 users.",
            disclaimer2: "**Workspace Premium service does not include Workspace Analytics for on-prem Citrix Virtual Apps and Desktops deployments."
        },
        calculator: {
            edition: "Select your edition",
            title: "Calculate your pricing",
            users: "Select your users",
            estCost: "Your estimated monthly cost",
            btn1: "Talk to an expert",
            btn1_link: "/products/citrix-workspace/form/pricing-inquiry/",
            minUserMsg: "Licensing options start at 25 users. Please try again.",
            lowUserMsg: "Have <500 users? We can help with your small or medium business needs.",
            volumeDiscount: "2500+ users? Enjoy discounted volume pricing.",
            contract1: "1 year contract",
            contract3: "3 year contract",
            contract3savings: "20% savings",
            term: "Per user, per month",
            disclaimer: "*This calculator provides estimated pricing and is to be used for budgeting purposes only. Actual prices may vary. Reach out to your Citrix team or partner for applicable discounts."
        },
        stats: {
            title: "Your benefits",
            stat1: {
                title: "Improve the employee experience",
                desc: "<b>4 out of 5</b> IT leaders believe employee experience is critical to their digital transformation."
            },
            stat2: {
                title: "Give employees choice",
                desc: "<b>78%</b> of business leaders agree that enabling employees to choose applications and devices they use helps to improve the employee experience."
            },
            stat3: {
                title: "Simplify access",
                desc: "<b>47%</b> of business leaders say that the biggest contribution to employee engagement is ease of access to information required to get work done."
            },
            btn1: "Talk to an expert",
            disclaimer: "Source: <a href='https://theexperienceofwork.economist.com/Citrix_The_Experience_of_Work_BriefingPaper.pdf' target='_blank'>The Economist</a>"
        }
    }
}